import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from '../../../environments/environment.dev';
import { BaseService } from "../../@core/services/base.service";
import { IConstructionAttachment } from "../models/settings.model";

@Injectable({ providedIn: 'root' })
export class ConstructionAttachmentService extends BaseService {


    constructor(
        protected override http: HttpClient
    ) {
        super(http);
    }


    apiUrl = environment.apiUrl + '/construction-attachment';

    fetchAttachments(filters: { searchValue: string, skip: number, limit: number }) {
        return this.post<{ constructionAttachments: IConstructionAttachment[], total: number }>(this.apiUrl, filters)
    }

    uploadAttachment(file: File, attachmentId: string) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('attachmentId', attachmentId);
        return this.post<IConstructionAttachment>(this.apiUrl + '/upload', formData)
    }

    deleteAttachment(attachmentId: string) {
        return this.delete(this.apiUrl + '/' + attachmentId)
    }

    removeAttachment(attachmentId: string) {
        return this.delete(this.apiUrl + '/remove/' + attachmentId)
    }

    updateConstructionAttachment(data: FormData) {
        return this.put<IConstructionAttachment>(this.apiUrl, data)
    }



}
